// LikedDatsScreen.jsx
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';
import DATbgcard from './assets/DATbgcard.png';
import BlankBG from './assets/BlankBG.png';
import LikeIconActive from './assets/LikeIconActive.png';
import LikeIcon from './assets/LikeIcon.png';

export default function LikedDatsScreen() {
  const navigate = useNavigate();
  const { assetsSummary, userWallet, setUserWallet, setAssetsSummary } = useContext(AppContext);
  const [likedAssets, setLikedAssets] = useState([]);

  useEffect(() => {
    if (assetsSummary && userWallet) {
      const likedIds = userWallet.likes || [];
      setLikedAssets(
        assetsSummary.filter(asset => likedIds.includes(asset.id))
      );
    }
  }, [assetsSummary, userWallet]);

  const handleLikePress = async (assetId) => {
    // toggle like locally
    const already = userWallet.likes.includes(assetId);
    // update local wallet likes
    setUserWallet(prev => ({
      ...prev,
      likes: already
        ? prev.likes.filter(id => id !== assetId)
        : [...(prev.likes || []), assetId]
    }));
    // update summary counts locally
    setAssetsSummary(prev =>
      prev.map(a =>
        a.id === assetId
          ? { ...a, likeCount: already ? Math.max(0, a.likeCount - 1) : (a.likeCount || 0) + 1 }
          : a
      )
    );
  };

  const goToDetail = dat =>
    navigate(`/dat/${dat.id}`, { state: { dat } });

  return (
    <div style={styles.page}>
      <img src={BlankBG} style={styles.fullScreenImage} alt="bg" />
      <div style={styles.headerRow}>
        <button onClick={() => navigate(-1)} style={styles.backArrow}>←</button>
        <h1 style={styles.headerTitle}>Liked DATS</h1>
      </div>
      <div style={styles.scrollContainer}>
        {likedAssets.length ? (
          <div style={styles.gridContainer}>
            {likedAssets.map(item => {
              const forSale = (item.editions || []).filter(e => e.isForSale);
              const edition = forSale.pop() || null;
              const editionNum = edition?.edition || 1;
              const editionPrice = edition?.price || item.cost;

              return (
                <div
                  key={item.id}
                  style={styles.card}
                  onClick={() => goToDetail(item)}
                >
                  <div
                    style={{
                      ...styles.cardBackground,
                      backgroundImage: `url(${DATbgcard})`
                    }}
                  >
                    {item.ArtworkURL && (
                      <img
                        src={item.ArtworkURL}
                        style={styles.nftImage}
                        alt="art"
                      />
                    )}
                    <div style={styles.nftId}>
                      {`${item.SongName} #${editionNum}`}
                    </div>
                    <div style={styles.price}>
                      {`$${editionPrice?.toLocaleString()}`}
                    </div>
                    <button
                      style={styles.iconButtonLike}
                      onClick={e => {
                        e.stopPropagation();
                        handleLikePress(item.id);
                      }}
                    >
                      <img
                        src={userWallet.likes.includes(item.id) ? LikeIconActive : LikeIcon}
                        style={styles.iconImage}
                        alt="like"
                      />
                      <span style={styles.likeCount}>
                        {item.likeCount || 0}
                      </span>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={styles.likePrompt}>
            <button
              style={styles.promptBtn}
              onClick={() => navigate('/music')}
            >
              Like your first DAT!
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    backgroundColor: '#000'
  },
  fullScreenImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 0
  },
  headerRow: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    height: 50,
    backgroundColor: '#0e061e',
    paddingTop: '10px',
    zIndex: 10
  },
  backArrow: {
    background: 'none',
    border: 'none',
    color: '#fff',
    fontSize: 24,
    position: 'absolute',
    cursor: 'pointer'
  },
  headerTitle: {
    flex: 1,
    textAlign: 'center',
    color: '#fff',
    fontSize: 20,
    alignSelf: 'center',
    fontWeight: 'bold'
  },
  scrollContainer: {
    position: 'absolute',
    top: 50,
    bottom: 0,
    left: 0,
    right: 0,
    overflowY: 'auto',
    zIndex: 2,
    padding: '16px',
    paddingBottom: '400px',
  },
  gridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16
  },
  card: {
    width: 'calc(50% - 16px)',
    borderRadius: 16,
    overflow: 'hidden',
    cursor: 'pointer',
    position: 'relative'
  },
  cardBackground: {
    width: '100%',
    height: 0,
    paddingBottom: '133%', // aspect ratio 3:4
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative'
  },
  nftImage: {
    position: 'absolute',
    top: '4px',
    left: '4px',
    width: '95%',
    height: '70%',
    objectFit: 'cover',
    borderRadius: '10px 10px 0 0',
    zIndex: 1
  },
  nftId: {
    position: 'absolute',
    bottom: '48px',
    left: 8,
    color: '#fff',
    fontWeight: 600,
    zIndex: 2
  },
  price: {
    position: 'absolute',
    bottom: '25px',
    left: 8,
    color: '#fff',
    fontWeight: 600,
    zIndex: 2
  },
  iconButtonLike: {
    position: 'absolute',
    bottom: 4,
    left: 4,
    background: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    zIndex: 2
  },
  iconImage: {
    width: 17,
    height: 17
  },
  likeCount: {
    color: '#fff',
    marginLeft: 4
  },
  likePrompt: {
    marginTop: 20,
    textAlign: 'center'
  },
  promptBtn: {
    border: 'none',
    background: 'transparent',
    color: '#62fbfa',
    fontSize: '2.1vh',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontFamily: 'brhendrix'
  }
};
